import { useQuery } from "react-query";
import { getCourseCompletion } from "@/api";
import { useUser } from "@/providers/context";
import { useCallback, useMemo } from "react";

export const useCourseCompletion = (courseId: number) => {
  const { uid } = useUser();

  const query = useQuery({
    queryKey: ["course-completion", uid, courseId],
    queryFn: () =>
      getCourseCompletion({ userID: uid ?? "", courseID: courseId }),
    enabled: !!uid,
  });

  const watchedVideosSet = useMemo(() => {
    return new Set(query.data?.watched_videos ?? []);
  }, [query.data?.watched_videos]);

  const isVideoWatched = useCallback(
    (videoId: string) => {
      return watchedVideosSet.has(videoId);
    },
    [watchedVideosSet],
  );

  return { ...query, isVideoWatched };
};
